module.exports = __webpack_public_path__ + "img/gb9117_7_d.prt.17585e37.jpg";